@if (useFastIconType) {
    <vn-menu-item [item]="item" [displayMode]="MenuDisplayMode.FastIcon" [section]="MenuSection.Login" iconClass="ui-icon ui-icon-size-xl" />
} @else {
    <vn-menu-item [item]="item" [displayMode]="MenuDisplayMode.Icon" [section]="MenuSection.Login" iconClass="ui-icon ui-icon-size-xl" />
}
